import {
  type EWebAnalyticsCompareMode,
  type IWebAnalyticsPeriod,
} from '@mahawi/eshop-common';
import dayjs, { type Dayjs } from 'dayjs';

import {
  EDateRangePreset,
  fromInclusiveDates,
  type IDateRange,
  resolveDateRange,
  type TDateRangePreset,
  toInclusiveDates,
} from '../../fragments/date-range';

export const WEB_ANALYTICS_DATE_RANGE_PRESETS: readonly TDateRangePreset[] = [
  EDateRangePreset.YESTERDAY,
  EDateRangePreset.LAST_7_DAYS,
  EDateRangePreset.LAST_14_DAYS,
  EDateRangePreset.LAST_30_DAYS,
  EDateRangePreset.LAST_90_DAYS,
  EDateRangePreset.LAST_365_DAYS,
  EDateRangePreset.THIS_WEEK,
  EDateRangePreset.LAST_WEEK,
  EDateRangePreset.THIS_MONTH,
  EDateRangePreset.LAST_MONTH,
  EDateRangePreset.THIS_QUARTER,
  EDateRangePreset.LAST_QUARTER,
  EDateRangePreset.THIS_YEAR,
  EDateRangePreset.LAST_YEAR,
];

export const WEB_ANALYTICS_DEFAULT_PRESET: TDateRangePreset =
  EDateRangePreset.LAST_30_DAYS;

export const getWebAnalyticsEndBefore = (now: Dayjs = dayjs()): Dayjs =>
  now.startOf('day');

export const toWebAnalyticsPeriod = (
  range: IDateRange,
  compare: EWebAnalyticsCompareMode,
): IWebAnalyticsPeriod => {
  const [dateFrom, dateTo]: [string, string] = toInclusiveDates(range);

  return { dateFrom, dateTo, compare };
};

export const fromWebAnalyticsPeriod = ({
  dateFrom,
  dateTo,
}: Pick<IWebAnalyticsPeriod, 'dateFrom' | 'dateTo'>): IDateRange =>
  fromInclusiveDates(dateFrom, dateTo);

export const resolvePresetPeriod = (
  preset: TDateRangePreset,
  compare: EWebAnalyticsCompareMode,
  now: Dayjs = dayjs(),
): IWebAnalyticsPeriod =>
  toWebAnalyticsPeriod(
    resolveDateRange(preset, now, getWebAnalyticsEndBefore(now)),
    compare,
  );
